(function() {

	$( document ).ready( function() {

		var uploadForm = $( '.with-uploads' );
		var defaultForm = $( '.without-uploads' );
		var offset = '';
		var pages = [];
		var pageCounter = -1;

		let files = [];

		defaultForm.submit( function( event ){

			event.preventDefault();

			$( '.form-contest-fieldset' ).attr( 'disabled', true );
			$( '.form-contest-submit-button' ).addClass( 'submitting' );

			var firstName = $( '#form-contest-first-name' ).val();
			var lastName = $( '#form-contest-last-name' ).val();
			var email = $( '#form-contest-email' ).val();
			var phone = $( '#form-contest-phone' ).val();
			var email = $( '#form-contest-email' ).val();

			if( $( '#form-contest-newsletter' ).is( ':checked' ) ){
				var newsletter = true;
			} else {
				var newsletter = false;
			}


			$.ajax({
				async : true,
				crossDomain : true,
				processData : false,
				method : 'get',
				url: 'https://api.airtable.com/v0/'+ window.theme.airtable.base + '/Submissions',
				headers : {
					'Authorization' : 'Bearer ' +  window.theme.airtable.token,
					'Content-Type' : 'application/json'
				},
				success : function( response ){

					var existingSubmission = response.records.filter( function( record ){

						return record.fields.Email == email;

					});

					if( existingSubmission && existingSubmission.length == 0 ){

						$.ajax({
							async : true,
							crossDomain : true,
							processData : false,
							method : 'Post',
							url: 'https://api.airtable.com/v0/'+ window.theme.airtable.base + '/Submissions',
							headers : {
								'Authorization' : 'Bearer ' +  window.theme.airtable.token,
								'Content-Type' : 'application/json'
							},
							data : JSON.stringify({
								'fields' : {
									'First Name' : firstName,
									'Last Name' : lastName,
									'Email' : email,
									'Phone' : phone,
									'Newsletter' : newsletter,
								}}
							),
							success : function( response ){

								$( '.form-contest-inner' ).hide();
								$( '.form-contest-fieldset' ).attr( 'disabled', false );
								$( '.form-contest-submit-button' ).removeClass( 'submitting' );
								$( '.form-contest-legal' ).hide();
								$( '.form-contest-confirmation' ).show();

								window.dataLayer.push({
									'event' : 'Form Submission',
									'type' : 'Contest'
								})

							},
							error : function( error ){
								console.log( 'error 2' );
								console.log( error );

							}
						});

					} else {

						$( '.form-contest-inner' ).hide();
						$( '.form-contest-fieldset' ).attr( 'disabled', false );
						$( '.form-contest-submit-button' ).removeClass( 'submitting' );
						$( '.form-contest-legal' ).hide();
						$( '.form-contest-already-submitted' ).show();

					}


				},
				error : function( error ){
					console.log( 'error 1' );
					console.log( error );

				}
			});

		});

		$( '#sticky-contest' ).on( 'click', function( event ){

			window.dataLayer.push({
				'event' : 'Click',
				'type' : 'Contest'
			})

		});

		function containsObject( obj, list ) {

			var i;

			for ( i = 0; i < list.length; i++ ) {

				if ( JSON.stringify( list[ i ].results ) === JSON.stringify( obj ) ) {

					return true;

				}

			}

			return false;
		}

		if( document.querySelector('.submissions-wrapper') ) {

			const base = $( '.submissions-wrapper' ).data( 'contestBase' );
			const list = $( '.submissions-wrapper' ).data( 'contestList' );

			$.ajax({
				async : true,
				crossDomain : true,
				processData : false,
				method : 'get',
				url: 'https://api.airtable.com/v0/'+ base + '/' + list + '?filterByFormula=Status="Accepted"&pageSize=24',
				headers : {
					'Authorization' : 'Bearer ' +  window.theme.airtable.token,
					'Content-Type' : 'application/json'
				},
				success : function( response ) {

					if( response.records.length > 0 ) {

						$( response.records ).each( ( index, record ) => {

							if( record.fields.Attachments.length > 1 ) {

								let modalContent = '';
								let titleContent = '';

								$( record.fields.Attachments ).each( ( index, attachment ) => {

									if( attachment.filename && attachment.filename.indexOf( '.png' ) == -1 && attachment.filename.indexOf( '.jpg' ) == -1 && attachment.filename.indexOf( '.jpeg' ) == -1 ) {

										titleContent = '<span>Title: ' + attachment.filename + '</span>';

									}

									modalContent += '<div class="slide-inner"><div class="background-graphic"></div><div class="img-wrapper"><img src="' +  attachment.url + '" /></div><div class="info-bar"><span>Submitted By: '+ record.fields[ 'First Name' ] + '</span>' + titleContent + '</div></div>';

								});

								$( '.submissions-row' ).append(
									'<div class="submission-modal" id="submission-modal-' + index + '">'+
									'<div class="submission-slider-wrapper" >'+
									'<div class="submission-slider">'+
									modalContent +
									'</div>' +
									'</div>'+
									'</div>'+
									'<div class="col-span-6 md:col-span-4">' +
									'<a id="submission-trigger-' + index + '" href="#submission-modal-' + index + '" class="submission-item multiple-submissions submission-trigger" style="background-image: url(' + record.fields.Attachments[ 0 ].url + ')">' +
									'<div class="submission-count">' + record.fields.Attachments.length + '</div>'+
									'</a>'+
									'</div>'
								);

							} else {

								let titleContent = '';

								if( record.fields.Attachments[ 0 ].filename && record.fields.Attachments[ 0 ].filename.indexOf( '.png' ) == -1 && record.fields.Attachments[ 0 ].filename.indexOf( '.jpg' ) == -1 && record.fields.Attachments[ 0 ].filename.indexOf( '.jpeg' ) == -1 ) {

									titleContent = '<span>Title: ' + record.fields.Attachments[ 0 ].filename + '</span>';

								}

								$( '.submissions-row' ).append(
									'<div class="submission-modal" id="submission-modal-' + index + '">'+
									'<div class="image-wrapper">' +
									'<img src="' + record.fields.Attachments[ 0 ].url + '" /><div class="info-bar"><span>Submitted By: '+ record.fields[ 'First Name' ] + '</span>' + titleContent + '</div>' +
									'</div>' +
									'</div>'+
									'<div class="col-span-6 md:col-span-4">' +
									'<a id="submission-trigger-' + index + '" href="#submission-modal-' + index + '" class="submission-item submission-trigger" style="background-image: url(' + record.fields.Attachments[ 0 ].url + ')">' +
									'</a>'+
									'</div>'
								);

							}

						});

					}

					pages.push( {
						offset : response?.offset || '',
						results : response.records
					});

					if( response.offset ) {

						offset = response.offset;

						$( '.submission-pagination' ).addClass( 'active' );

					}


				},
				error : function( error ){

					console.log( error );

				}
			});

			//pagination functionality
		$( '.next-page' ).on( 'click', function() {

			if( offset != '' ) {

				pageCounter++;

				$.ajax({
					async : true,
					crossDomain : true,
					processData : false,
					method : 'get',
					url: 'https://api.airtable.com/v0/'+ base + '/' + list + '?filterByFormula=Status="Accepted"&pageSize=24&offset=' + offset,
					headers : {
						'Authorization' : 'Bearer ' +  window.theme.airtable.token,
						'Content-Type' : 'application/json'
					},
					success : function( response ) {

						if( response.records.length > 0 ) {

							$( '.submissions-row' ).html('');

							$( response.records ).each( ( index, record ) => {

								if( record.fields.Attachments.length > 1 ) {

									let modalContent = '';
									let titleContent = '';

									$( record.fields.Attachments ).each( ( index, attachment ) => {

										if( attachment.filename && attachment.filename.indexOf( '.png' ) == -1 && attachment.filename.indexOf( '.jpg' ) == -1 && attachment.filename.indexOf( '.jpeg' ) == -1 ) {

											titleContent = '<span>Title: ' + attachment.filename + '</span>';

										}

										modalContent += '<div class="slide-inner"><div class="background-graphic"></div><div class="img-wrapper"><img src="' +  attachment.url + '" /></div><div class="info-bar"><span>Submitted By: '+ record.fields[ 'First Name' ] + '</span>' + titleContent + '</div></div>';

									});

									$( '.submissions-row' ).append(
										'<div class="submission-modal" id="submission-modal-' + index + '">'+
										'<div class="submission-slider-wrapper" >'+
										'<div class="submission-slider">'+
										modalContent +
										'</div>' +
										'</div>'+
										'</div>'+
										'<div class="col-span-6 md:col-span-4">' +
										'<a id="submission-trigger-' + index + '" href="#submission-modal-' + index + '" class="submission-item multiple-submissions submission-trigger" style="background-image: url(' + record.fields.Attachments[ 0 ].url + ')">' +
										'<div class="submission-count">' + record.fields.Attachments.length + '</div>'+
										'</a>'+
										'</div>'
									);

								} else {

									let titleContent = '';

									if( record.fields.Attachments[ 0 ].filename && record.fields.Attachments[ 0 ].filename.indexOf( '.png' ) == -1 && record.fields.Attachments[ 0 ].filename.indexOf( '.jpg' ) == -1 && record.fields.Attachments[ 0 ].filename.indexOf( '.jpeg' ) == -1 ) {

										titleContent = '<span>Title: ' + record.fields.Attachments[ 0 ].filename + '</span>';

									}

									$( '.submissions-row' ).append(
										'<div class="submission-modal" id="submission-modal-' + index + '">'+
										'<div class="image-wrapper">' +
										'<img src="' + record.fields.Attachments[ 0 ].url + '" /><div class="info-bar"><span>Submitted By: '+ record.fields[ 'First Name' ] + '</span>' + titleContent + '</div>' +
										'</div>' +
										'</div>'+
										'<div class="col-span-6 md:col-span-4">' +
										'<a id="submission-trigger-' + index + '" href="#submission-modal-' + index + '" class="submission-item submission-trigger" style="background-image: url(' + record.fields.Attachments[ 0 ].url + ')">' +
										'</a>'+
										'</div>'
									);

								}

							});

						}

						var arrayCheck = containsObject( response.records, pages );

						if( !arrayCheck ) {

							pages.push( {
								offset : response?.offset || '',
								results : response.records
							});

						}


						if( response.offset ) {

							offset = response.offset;

						} else {

							offset = '';

						}

						$( '.submission-trigger' ).each( function() {

							$( this ).fancybox({
								type : 'inline',
								baseClass : 'modal-inline-wrap',
								touch : false
							});

						});

						$( '.submission-trigger' ).on( 'click', function() {

							const target = $( this ).attr( 'id' ).split( 'submission-trigger-' )[ 1 ];

							setTimeout( function() {
								$( '#submission-modal-' + target + '> .submission-slider-wrapper > .submission-slider' ).each( function() {

									$( this ).not('.slick-initialized').slick({
										slidesToShow : 1,
										slidesToScroll : 1,
										arrows : true,
										dots : false,
										autoplay: false,
										adaptiveHeight: true
									});



								});
							}, 20 );

						});

					},
					error : function( error ){

						console.log( error );

					}
				});

			}

		});

		$( '.previous-page' ).on( 'click', function() {

			if( pageCounter >= 0 ) {

				var renderPage = pages[ pageCounter ];

				offset = renderPage.offset;

				if( renderPage.results.length > 0 ) {

					$( '.submissions-row' ).html('');

					$( renderPage.results ).each( ( index, record ) => {

						if( record.fields.Attachments.length > 1 ) {

							let modalContent = '';
							let titleContent = '';

							$( record.fields.Attachments ).each( ( index, attachment ) => {

								if( attachment.filename && attachment.filename.indexOf( '.png' ) == -1 && attachment.filename.indexOf( '.jpg' ) == -1 && attachment.filename.indexOf( '.jpeg' ) == -1 ) {

									titleContent = '<span>Title: ' + attachment.filename + '</span>';

								}

								modalContent += '<div class="slide-inner"><div class="background-graphic"></div><div class="img-wrapper"><img src="' +  attachment.url + '" /></div><div class="info-bar"><span>Submitted By: '+ record.fields[ 'First Name' ] + '</span>' + titleContent + '</div></div>';

							});

							$( '.submissions-row' ).append(
								'<div class="submission-modal" id="submission-modal-' + index + '">'+
								'<div class="submission-slider-wrapper" >'+
								'<div class="submission-slider">'+
								modalContent +
								'</div>' +
								'</div>'+
								'</div>'+
								'<div class="col-span-6 md:col-span-4">' +
								'<a id="submission-trigger-' + index + '" href="#submission-modal-' + index + '" class="submission-item multiple-submissions submission-trigger" style="background-image: url(' + record.fields.Attachments[ 0 ].url + ')">' +
								'<div class="submission-count">' + record.fields.Attachments.length + '</div>'+
								'</a>'+
								'</div>'
							);

						} else {

							let titleContent = '';

							if( record.fields.Attachments[ 0 ].filename && record.fields.Attachments[ 0 ].filename.indexOf( '.png' ) == -1 && record.fields.Attachments[ 0 ].filename.indexOf( '.jpg' ) == -1 && record.fields.Attachments[ 0 ].filename.indexOf( '.jpeg' ) == -1 ) {

								titleContent = '<span>Title: ' + record.fields.Attachments[ 0 ].filename + '</span>';

							}

							$( '.submissions-row' ).append(
								'<div class="submission-modal" id="submission-modal-' + index + '">'+
								'<img src="' + record.fields.Attachments[ 0 ].url + '" /><div class="info-bar"><span>Submitted By: '+ record.fields[ 'First Name' ] + '</span>' + titleContent + '</div>' +
								'</div>'+
								'<div class="col-span-6 md:col-span-4">' +
								'<a id="submission-trigger-' + index + '" href="#submission-modal-' + index + '" class="submission-item submission-trigger" style="background-image: url(' + record.fields.Attachments[ 0 ].url + ')">' +
								'</a>'+
								'</div>'
							);

						}

					});

					$( '.submission-trigger' ).each( function() {

						$( this ).fancybox({
							type : 'inline',
							baseClass : 'modal-inline-wrap',
							touch : false
						});

					});

					$( '.submission-trigger' ).on( 'click', function() {

						const target = $( this ).attr( 'id' ).split( 'submission-trigger-' )[ 1 ];

						setTimeout( function() {
							$( '#submission-modal-' + target + '> .submission-slider-wrapper > .submission-slider' ).each( function() {

								$( this ).not('.slick-initialized').slick({
									slidesToShow : 1,
									slidesToScroll : 1,
									arrows : true,
									dots : false,
									autoplay: false,
									adaptiveHeight: true
								});



							});
						}, 20 );

					});

				}
			}

			pageCounter--;

		});

		$( document ).ajaxStop(function () {

			$( '.submission-trigger' ).each( function() {

				$( this ).fancybox({
					type : 'inline',
					baseClass : 'modal-inline-wrap',
					touch : false
				});

			});

			$( '.submission-trigger' ).on( 'click', function() {

				const target = $( this ).attr( 'id' ).split( 'submission-trigger-' )[ 1 ];

				setTimeout( function() {
					$( '#submission-modal-' + target + '> .submission-slider-wrapper > .submission-slider' ).each( function() {

						$( this ).not('.slick-initialized').slick({
							slidesToShow : 1,
							slidesToScroll : 1,
							arrows : true,
							dots : false,
							autoplay: false,
							adaptiveHeight: true
						});



					});
				}, 20 );

			});

		});

		}

		//form step functionality

		$( '.form-contest-back-button' ).on( 'click', function() {

			$( '#uploader-fieldset' ).removeClass( 'active' );
			$( '#form-fieldset' ).addClass( 'active' );

		});


		$( '.form-contest-next-button' ).on( 'click', function() {

			if( $( '.form-contest-form' )[ 0 ].checkValidity() ) {

				$( '#uploader-fieldset' ).addClass( 'active' );
				$( '#form-fieldset' ).removeClass( 'active' );

			} else {

				uploadForm[ 0 ].reportValidity();

			}

		});

		//uppy init

		if( $( '.sticky-link' ).length > 0 && $( '#drag-drop-area' ).length > 0 ) {

			const { Form } = Uppy;
			const { XHRUpload } = Uppy

			var uppy = new Uppy.Core({
				autoProceed : false,
				restrictions : {
					maxFileSize: parseInt( window.theme.contest.fileSize ),
					maxNumberOfFiles: window.theme.contest.fileLimit,
					minNumberOfFiles: 1,
					allowedFileTypes: ['image/jpg', 'image/jpeg', 'image/png'],
				},
				meta : {
					"UPLOADCARE_PUB_KEY": "2397a94d2a05c3ce8d4e"
				}
			});

			uppy.use( Uppy.Dashboard, {
				trigger : null,
				inline: true,
				hideUploadButton: true,
				target: '#drag-drop-area',
				note: 'Images only, 1–5 files, up to 2 MB',
				width: '100%',
				maxWidth: '375px',
				height: 405,
				showProgressDetails: true,
				metaFields: [
					{ id: 'name', name: 'Name', placeholder: 'Title Your Image' },
				]
			});

			uppy.use( Form, {
				target: '.form-contest-form',
				resultName: "uppyResult",
				getMetaFromForm: true,
				addResultToForm: true,
				multipleResults: true,
				submitOnSuccess: false,
				triggerUploadOnSubmit: true
			});

			uppy.use( XHRUpload, {
				endpoint: 'https://upload.uploadcare.com/base/',
				method: 'post',
				headers : {
					"Accept": "application/vnd.uploadcare-v0.5+json",
					"Authorization": "Uploadcare.Simple demopublickey:demoprivatekey"
				}
			} );

			//form submission functionality
			uppy.on('upload-success', ( file, response ) => {

				const httpBody = response.body   // extracted response data

				files.push({
					...httpBody,
					...file
				});
			});

			uppy.on( 'complete', ( result ) => {

				$( '.form-contest-fieldset' ).attr( 'disabled', true );
				$( '.submit-target' ).addClass( 'submitting' );

				var firstName = $( '#form-contest-first-name' ).val();
				var lastName = $( '#form-contest-last-name' ).val();
				var email = $( '#form-contest-email' ).val();
				var phone = $( '#form-contest-phone' ).val();
				var email = $( '#form-contest-email' ).val();

				if( $( '#form-contest-newsletter' ).is( ':checked' ) ) {

					var newsletter = true;

				} else {

					var newsletter = false;

				}

				$.ajax({
					async : true,
					crossDomain : true,
					processData : false,
					method : 'get',
					url: 'https://api.airtable.com/v0/'+ window.theme.airtable.base + '/Submissions',
					headers : {
						'Authorization' : 'Bearer ' +  window.theme.airtable.token,
						'Content-Type' : 'application/json'
					},
					success : function( response ){

						uppy.reset();

						var existingSubmission = response.records.filter( function( record ){

							return record.fields.Email == email;

						});

						if( existingSubmission && existingSubmission.length == 0 ){

							$.ajax({
								async : true,
								crossDomain : true,
								processData : false,
								method : 'Post',
								url: 'https://api.airtable.com/v0/'+ window.theme.airtable.base + '/Submissions',
								headers : {
									'Authorization' : 'Bearer ' +  window.theme.airtable.token,
									'Content-Type' : 'application/json'
								},
								data : JSON.stringify({
									'fields' : {
										'First Name' : firstName,
										'Last Name' : lastName,
										'Email' : email,
										'Phone' : phone,
										'Newsletter' : newsletter,
										'Attachments' : files.map( ( file ) => {

											return {
												"url" : 'https://ucarecdn.com/' + file.file + '/',
												"filename": file?.meta?.name,
											};

										}),
										"Status" : 'Pending'
									}}
								),
								success : function( response ){

									uppy.setState({ currentUploads: {} });

									files = [];

									$( '.form-contest-inner' ).hide();
									$( '.form-contest-fieldset' ).attr( 'disabled', false );
									$( '.form-contest-submit-button' ).removeClass( 'submitting' );
									$( '.form-contest-legal' ).hide();
									$( '.form-contest-confirmation' ).show();

									$( '#uploader-fieldset' ).removeClass( 'active' );
									$( '#form-fieldset' ).addClass( 'active' );

									window.dataLayer.push({
										'event' : 'Form Submission',
										'type' : 'Contest'
									});

								},
								error : function( error ){

									console.log( error );

								}
							});

						} else {

							$( '.form-contest-inner' ).hide();
							$( '.form-contest-fieldset' ).attr( 'disabled', false );
							$( '.submit-target' ).removeClass( 'submitting' );
							$( '.form-contest-legal' ).hide();
							$( '.form-contest-already-submitted' ).show();

							$( '#uploader-fieldset' ).removeClass( 'active' );
							$( '#form-fieldset' ).addClass( 'active' );

						}

					},
					error : function( error ){

						console.log( error );

					}
				});

			});

		}

		//multi-page form validation

	});

})();
